/**
 * @author Yakov.Gushchin
 * @version 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../theme';

/**
 * @interface IRangeContainerStyleProps
 * @description Define styled props for range container.
 * @see IRangeInputProps
 *
 * @property{string} widthSize Define container width.
 */
interface IRangeContainerStyleProps {
    widthSize: string;
}

/**
 * @interface IRangeDividerStyleProps
 * @description Define styled props for range divider between inputs.
 * @see IRangeInputProps
 *
 * @property{string} spaceBetween Define space between left and right input.
 */
interface IRangeDividerStyleProps {
    spaceBetween: string;
}

const RangeContainerStyled = styled.div<IRangeContainerStyleProps>`
    display: flex;
    align-items: center;
    width: ${(props) => props.widthSize};
    margin-bottom: 24px;
    & input.range-input__input-error {
      border-color: ${colors.borderColorError} !important; 
    }
`;

const LeftContainerStyled = styled.div`
    flex-grow: 1;
`;

const RightContainerStyled = styled.div`
    flex-grow: 1;
`;

const DividerStyled = styled.div<IRangeDividerStyleProps>`
    flex-grow: 1;
    padding-left: ${(props) => props.spaceBetween};
`;

export {
    DividerStyled,
    LeftContainerStyled,
    RangeContainerStyled,
    RightContainerStyled,
};
